import { httpAuth } from "@/api/httpAuth";

export const metricsRequests = {
  create_metric: function ({ context, entity_id, entity_type, metadata, pk, rank, segments } = {}) {
    const data = {
      entity_id,
      entity_type,
      pk,
      rank,
    };

    if (segments) {
      data.segments = segments;
    }
    if (metadata) {
      data.metadata = metadata;
    }

    return httpAuth.post("/v1/metrics/create_metric", { context, json: data }).json();
  },
};
